import { ACCOUNT_USERS_CACHE_PREFIX } from 'constants/cache/accountUsersCache';
import oemManager from 'services/oem';

/**
 * Builds the IndexedDB bucket key for an account's users, scoped by environment.
 *
 * Returns `null` (→ callers skip the cache) when the key can't be built safely:
 * - no `PK_Account` — nothing to scope the bucket to;
 * - no environment (throws or empty) — the cache must not be used without an environment scope,
 *   otherwise accounts with the same PK_Account across environments could collide.
 *
 * @param {string|number} PK_Account - Account whose bucket key to build.
 * @returns {string|null} e.g. `account-users-uuid:vera:13714114`, or `null` when key can't be built.
 */
export const buildAccountUsersCacheKey = (PK_Account) => {
    if (!PK_Account) {
        return null;
    }

    let env;
    try {
        env = oemManager.getEnvironmentKey();
    } catch {
        env = undefined;
    }

    if (!env) {
        return null;
    }

    return `${ACCOUNT_USERS_CACHE_PREFIX}${env}:${PK_Account}`;
};
